import axios from "../../axios/axios-api";
import axiosCenso from "../../axios/axios-censo";

export const realizarAlta = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso
    let header = { headers: { Authorization: "Bearer " + token }}

    return axios
    .put("/api/censo/realizarAlta", payload, header)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg: resp.data.msg}, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg}, { root: true })

    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });

};

export const atualizaDadosCns = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit("sessao/setError", null, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso

    let config = {
        headers: { Authorization: "Bearer " + token },
        params: {
            tipoDocumento: 'cns',
            numeroDocumento: payload.cns,
            'g-recaptcha-response': payload.captcha,
            idLeito: payload.id,
            pacienteId: payload.pacienteId
        }
    }
    
    return axiosCenso
    .get("atualizarDadosPaciente.php", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })

        if (resp.data.status == false) commit("sessao/setError", {status: false, msg:  resp.data.msg }, { root: true })
        if (resp.data.status == true) commit("sessao/setError", {status: true, msg: resp.data.msg }, { root: true })
    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
    });
 
};